<template>
  <div>
    <v-sheet class="py-4 py-md-6" color="primary">
      <TitleWidget dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-container class="pb-10 pb-md-13 pb-lg-16 item">
      <TitleWidget class="mt-6">
        {{ item.title }}
      </TitleWidget>

      <v-row justify="center" no-gutters>
        <v-col cols="12" md="9">
          <img
            v-if="image"
            @error="onError"
            class="d-block mt-6"
            loading="lazy"
            :src="image + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
            :alt="item.title"
            width="100%"
          />

          <div
            v-if="item.text"
            class="
              grey--text
              text--darken-2 text-subtitle-1
              font-weight-light
              mt-6 mt-md-8
              item-text
              ck-content
            "
          >
            <span class="font-secondary" v-html="item.text"></span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import DefaultImg from "../assets/img/default-img.png";

const _config = {
  mod: "services",
};

const _data = {
  title: "Nossos Serviços",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    image() {
      if (this.item.img) return this.files + this.item.img;

      return "";
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getItem() {
      this.loading = true;

      this.$rest(_config.mod).get({
        id: this.itemId,
        save: (state, data) => (state.item = data),
      });
    },
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
  watch: {
    $route() {
      this.getItem();
    },
  },
  created() {
    this.getItem();
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.6;
  }

  &-video-content {
    aspect-ratio: 16 / 9;

    @media screen and (min-width: 960.001px) and (max-width: 1264px) {
      aspect-ratio: 1;
    }

    img,
    video {
      display: block;
      -o-object-fit: cover;
      object-fit: cover;
    }

    .item-video-mask {
      background-color: rgba(0, 0, 0, 0.5);
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      transition: all 0.1s linear;

      &-icon {
        opacity: 0.9;
        transition: all 0.1s linear;
      }
    }

    &:hover {
      .item-video-mask {
        background-color: rgba(0, 0, 0, 0.2);

        &-icon {
          opacity: 1;
        }
      }
    }
  }
}
</style>
